import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import Select from 'react-select';

/**
 * InteractiveTypeSection (presentational)
 * - Render Select untuk memilih interactive_type
 * - Logic/dispatch tetap di parent (QuestionsForm.jsx)
 */
export default function InteractiveTypeSection(props) {
  const {
    options,
    value,
    onChange,
    isDisabled,
    placeholder = 'Pilihlah tipe soal interaktif...',
    label = 'Tipe Interaktif',
  } = props;

  return (
    <FormGroup className="mb-3">
      <Label style={{ fontWeight: 'bold' }}>{label}:</Label>
      <Select
        className="basic-single"
        classNamePrefix="select"
        placeholder={placeholder}
        isClearable
        isSearchable
        name="interactive_type"
        options={options}
        onChange={onChange}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        value={value}
        isDisabled={isDisabled}
      />
    </FormGroup>
  );
}